"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const redux_1 = require("redux");
const react_ga4_1 = __importDefault(require("react-ga4"));
const AppRouter_1 = __importDefault(require("./components/router/AppRouter"));
const action_1 = require("./store/authentication/action");
// eslint-disable-next-line react/function-component-definition
const App = () => {
    const { dispatchInitialRequest } = (0, redux_1.bindActionCreators)({ dispatchInitialRequest: action_1.initialRequest }, (0, react_redux_1.useDispatch)());
    (0, react_1.useEffect)(() => {
        dispatchInitialRequest();
    }, []);
    if (process.env.GA_TAG) {
        react_ga4_1.default.initialize(process.env.GA_TAG);
    }
    return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(AppRouter_1.default, null)));
};
exports.default = App;
